export default "__VITE_ASSET__YiXh3oV9__"